import { Component, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogComponentInjectedData, ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AtLeastOneTrueValidation } from '@validators/at-least-one-true.validation';
import { DialogLocationService } from './dialogs/dialog-location/dialog-locations.service';
import { FilterLocationsComponent } from './filter/filter-locations.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  templateUrl: './locations.component.html',
  animations: fuseAnimations,
})
export class LocationComponent {
  public reload = new EventEmitter<Object>();

  public filtered: Boolean = false;
  public showMap: Boolean = false;
  public totalCount: Number = 0;

  public query = {
    name_contains: null,
    archived: false,
    companyId_in: [],
    documentNumber_contains: null
  };

  @ViewChild(FilterLocationsComponent, { static: true })
  public filters: FilterLocationsComponent;

  public hasEditLocationPermission = this.authenticationService.hasPermission('locations-edit');
  public hasCreateLocationPermission = this.authenticationService.hasPermission('locations-create');
  public hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly dialogLocationService: DialogLocationService,
    private readonly authenticationService: AuthenticationService,
    private readonly fuseSidebarService: FuseSidebarService,
    private readonly formBuilder: FormBuilder,
    private readonly matDialog: MatDialog,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public toggleSidebarOpen(name): void {
    this.fuseSidebarService.getSidebar(name).toggleOpen();
  }

  public setQuery(isFiltered: boolean): void {
    this.filtered = isFiltered;
  }

  public clearFilters(): void {
    this.filtered = false;
    this.filters.clearFilters();
  }

  public async openDialog(): Promise<void> {
    const result = await this.dialogLocationService.open({ locationId: null });
    if (result && result.reload) {
      this.reload.next();
    }
  }

  public openExportDialog(): void {
    const optionsForm = this.formBuilder.group({
      locations: true,
      companies: true,
      locationSectors: false,
      locationEnvironments: false,
    }, { validators: AtLeastOneTrueValidation.validate });

    this.matDialog.open(ExportDialogComponent, {
      panelClass: 'export-dialog',
      autoFocus: false,
      data: {
        type: ExportDialogTypeEnum.locations,
        limit: 30000,
        total: this.totalCount,
        optionsForm,
        where: this.filters.filtersChanged.value,
      } as ExportDialogComponentInjectedData
    });
  }
}
